import { createApi } from "@reduxjs/toolkit/query/react";
import type { GetScenarioRequest, GetScenarioResponse, ListScenariosRequest, ListScenariosResponse, SaveScenarioRequest, SaveScenarioResponse } from "../contracts";
import { baseQueryWithAuth } from "./api";
import { toDataSourceRequestString } from "@progress/kendo-data-query";

export const scenarioApi = createApi({
    reducerPath: "scenarioApi",
    baseQuery: baseQueryWithAuth,
    endpoints: builder => ({
        listScenarios: builder.query<ListScenariosResponse, ListScenariosRequest>({
            query: body => ({
                url: `scenario/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            })
        }),
        getScenario: builder.query<GetScenarioResponse, GetScenarioRequest>({
            query: body => ({
                url: "scenario",
                method: "POST",
                body
            })
        }),
        saveScenario: builder.mutation<SaveScenarioResponse, SaveScenarioRequest>({
            query: body => ({
                url: "scenario/save",
                method: "POST",
                body
            })
        })
    })
});

export const {
    useListScenariosQuery,
    useLazyListScenariosQuery,
    useGetScenarioQuery,
    useLazyGetScenarioQuery,
    useSaveScenarioMutation
} = scenarioApi;
